import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ModalModeRedirectGuard implements CanActivate {
    constructor(private router: Router) {}

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        const redirectRoute = route.data['modalRedirectRoute'];
        this.router.navigate([redirectRoute], { 
            queryParams: {
                showAsModal: true
            }, 
            queryParamsHandling: 'merge'}
        );
        return false;
    }
}
